import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShieldCheck, Wallet, MapPin } from "lucide-react";

const MESSAGES = [
  { icon: ShieldCheck, text: "20+ years of craftsmanship — licensed, insured & NJ HIC registered" },
  { icon: Wallet, text: "Honest, upfront pricing — no surprise change orders, ever" },
  { icon: MapPin, text: "Free estimates across Monmouth, Union, Middlesex & Ocean County" },
];

export const AnnouncementBar = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % MESSAGES.length), 4200);
    return () => clearInterval(t);
  }, []);

  const Active = MESSAGES[i].icon;

  return (
    <div
      data-testid="announcement-bar"
      style={{
        background:
          "linear-gradient(90deg, #0c3b31 0%, #14513f 50%, #0c3b31 100%)",
        borderBottom: "1px solid rgba(245,207,112,0.22)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "repeating-linear-gradient(90deg, rgba(255,255,255,0.04) 0px, rgba(255,255,255,0.04) 1px, transparent 1px, transparent 26px)",
          opacity: 0.5,
          pointerEvents: "none",
        }}
      />
      <div className="container-1200 relative" style={{ height: "40px" }}>
        <div className="h-full flex items-center justify-center px-8 sm:px-0">
          <AnimatePresence mode="wait">
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              className="flex items-center justify-center gap-2 sm:gap-2.5 text-center"
              data-testid={`announcement-msg-${i}`}
            >
              <Active size={14} strokeWidth={1.75} className="shrink-0" style={{ color: "var(--cta)" }} />
              <span
                className="text-[11.5px] sm:text-[13px]"
                style={{
                  color: "#eaf1fa",
                  fontWeight: 500,
                  letterSpacing: "0.01em",
                  lineHeight: 1.2,
                }}
              >
                {MESSAGES[i].text}
              </span>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="absolute right-0 top-1/2 -translate-y-1/2 hidden sm:flex gap-1.5">
          {MESSAGES.map((_, idx) => (
            <span
              key={idx}
              style={{
                width: idx === i ? 16 : 6,
                height: 4,
                borderRadius: 999,
                background: idx === i ? "var(--cta)" : "rgba(234,241,250,0.3)",
                transition: "all 0.3s ease",
                display: "inline-block",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
